import { render, staticRenderFns } from "./AuthWidget.vue?vue&type=template&id=32401834&scoped=true"
import script from "./AuthWidget.vue?vue&type=script&lang=js"
export * from "./AuthWidget.vue?vue&type=script&lang=js"
import style0 from "./AuthWidget.vue?vue&type=style&index=0&id=32401834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32401834",
  null
  
)

export default component.exports